import {BaseModel} from '@/core/standard/BaseModel';
import {
  ICategoryOption,
  IOptionModel,
  IOptions,
  IProductOption,
  OptionProtocol,
} from '@/modules/modifier-options/IOptionModel';
import OptionService from '@/modules/modifier-options/OptionService';


const option = {
  name: '',
  min_value: 1,
  max_value: 1,
  modifiers: [],
  ingredients: [],
  image: '',
  unit: '',
  unit_value_format: '',
  amount: '',
  price: '',
  product: '',
  name_es: '',
  name_en: '',
  is_quantifiable: false,
  enabled: false,
  modifier_id: null,
};

class OptionModel<T extends BaseModel<any, any>> extends BaseModel<IOptionModel, OptionProtocol, typeof OptionService> {
  public modelName = 'Option';

  public request = 'FormData';
  public relationModel: T = {} as T;

  constructor(relationModel: T) {
    super(option, OptionService);
    this.relationModel = relationModel;
  }

  public async mapRow(row: IOptionModel & { id: string | number }) {
    const fetchedRow = await this.service.getBy({query: {}, id: row.id});
    const {complete, data} = fetchedRow;
    super.mapRow(data);
  }

  public async insertMany(data: Array<IProductOption | ICategoryOption>, toast = null, toastConfig = null) {
    const inserted = await this.service.insertMany({query: data});
    if (inserted.complete) {
      return inserted.data;
    }
    return [];
  }

  public async save(toast: any = null, toastConfig: any = {}) {
    const formData = new FormData();
    Object.keys(option).forEach((field) => {
      if (this[field] !== null && this[field] !== undefined) {
        if (typeof this[field] === 'object' && !(this[field] instanceof File)) {
          formData.append(field, JSON.stringify(this[field]));
        } else {
          const splittedField = field.split('_');
          const lang = localStorage.getItem('lang') || 'es';
          if (splittedField[splittedField.length - 1] !== lang) {
            formData.append(field, this[field]);
          }
        }
      }
    });

    if (!formData.get('image')) {
      if (!formData.has('image')) {
        formData.append('image', '');
      }
    } else if (formData.has('image') && !(formData.get('image') instanceof File)) {
      formData.delete('image');
    }
    //@ts-ignore
    if (this.max_value > 1) {
      //@ts-ignore
      formData.set('is_quantifiable', true);
    }
    // @ts-ignore
    if (this.id) {
      // @ts-ignore
      formData.append('id', this.id);
      return this.update(formData, toast, toastConfig);
    } else {
      return this.create(formData, toast, toastConfig);
    }
  }


}

export default OptionModel as new() => IOptions<any>;
